import React, { useState } from 'react';
import { Modal, Divider, Button, Form, Input, Select, DatePicker, message } from 'antd';
import { NumericFormat } from 'react-number-format';
import dayjs from "dayjs";
import axios from "./../../../services/http";

const ModalAddPaymentCredit = ({
    obraId, title, openPaymentCreditDialog, 
    typeAmount, cancelPaymentCreditDialog,
    savedPaymentCredit
}) => {

    const [paymentCreditForm] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onValuesChange = (changedValues) => {
        if ('iva' in changedValues || 'importe' in changedValues) {
            let iva = paymentCreditForm.getFieldValue('iva');
            let importe = paymentCreditForm.getFieldValue('importe');

            if (importe !== undefined && typeof importe === "string") importe = parseFloat(importe.replace(/[$,]/g,'')).toFixed(2);

            if (importe !== undefined && iva !== undefined) {
                const importeIva = importe * (iva/100);
                paymentCreditForm.setFieldsValue({ montoIva: (parseFloat(importe) + parseFloat(importeIva)).toFixed(2) });
            }
        }
    };

    const handlePaymentCredit = async (values) => {
        try {
            setLoading(true);
            let { observaciones, importe, iva, montoIva, fecha } = values;

            const PaymentCredit = {
                observaciones, 
                importe: parseFloat(importe.replace(/[$,]/g,'')).toFixed(2), 
                iva: (typeAmount === "Fiscal" ? iva : 0),
                montoIva: (typeAmount === "Fiscal" ? montoIva : parseFloat(importe.replace(/[$,]/g,'')).toFixed(2)),
                fecha,
                obra_id: obraId,
                tipo: "ABONO_CREDITO",
                tipo_monto: typeAmount
            };

            const response = await axios.HTTP_POST("/api/v1/relationship/add-payment-credit", PaymentCredit);
            if (response) {
                message.success(response.data.message);
                savedPaymentCredit();
            }
        } catch (e) {
            console.error('Error al añadir el abono:', e);
            message.error('Hubo un error al añadir el abono');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Modal
                title={title}
                open={openPaymentCreditDialog}
                onCancel={() => cancelPaymentCreditDialog(false)}
                footer={null}
                >
                <Divider style={{ margin: '24px 0' }} />
                <Form
                    layout="vertical"
                    form={paymentCreditForm}
                    onFinish={handlePaymentCredit}
                    onValuesChange={onValuesChange}
                >
                    <Form.Item
                        label="Concepto"
                        name="observaciones"
                        rules={[{ required: true, message: 'Por favor ingresar el concepto' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Fecha"
                        name="fecha"
                        rules={[{ required: true, message: 'Por favor seleccionar una fecha' }]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            format="YYYY-MM-DD"
                            placeholder="Elige una fecha"
                            disabledDate={(current) => {
                                return current && current > dayjs().endOf('day');
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Monto"
                        name="importe"
                        rules={[{ required: true, message: 'Por favor ingresar el monto' }]}
                    >
                        <NumericFormat 
                            thousandSeparator={true} prefix={'$ '} 
                            customInput={Input}
                        />
                    </Form.Item>
                    {typeAmount === "Fiscal" ?
                        <>
                            <Form.Item
                                label="IVA"
                                name="iva"
                                rules={[{ required: true, message: 'Por favor selecciona el IVA' }]}
                            >
                                <Select placeholder="Selecciona una opción">
                                    <Select.Option value={8}>8%</Select.Option>
                                    <Select.Option value={16}>16%</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Monto C/ IVA"
                                name="montoIva"
                            >
                                <NumericFormat 
                                    thousandSeparator={true} prefix={'$ '} 
                                    customInput={Input}
                                    disabled
                                />
                            </Form.Item>
                        </>                        
                    :null}

                    <Divider style={{ margin: '24px 0' }} />
                    <Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                            <Button type="default" onClick={() => cancelPaymentCreditDialog(false)}>
                                Cancelar
                            </Button>
                            <Button type="primary" loading={loading} htmlType="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModalAddPaymentCredit;